import { render, staticRenderFns } from "./comingsoon_video.vue?vue&type=template&id=539565de&"
import script from "./comingsoon_video.vue?vue&type=script&lang=js&"
export * from "./comingsoon_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports